export default __webpack_public_path__ + "assets/12b93b4d09f6a73f4d48e94f33e878f1.png";